import { Question } from 'survey-core';

export const setPostalCodeValue = (postalCode: Question, value: string) => {
  // Deny rewriting value when postalCode already has value and it is in readOnly state
  if (postalCode.value && postalCode.readOnly) return;
  postalCode.value = value || '';
};
